import {useLocale} from "next-intl";
import {useState} from "react";
import {ExperianResult} from "@/types/experian";

const useAutocompleteAddress = () => {
  const locale = useLocale();
  const [addressOptions, setAddressOptions] = useState<ExperianResult[]>([]);

  const handleChange = async (value: string) => {
    const queryLength = value.replace(/\s/g, "").length;
    if (queryLength <= 5) return;

    try {
      const apiParams = new URLSearchParams({
        query: value ?? "",
        locale
      });

      const url = `/api/experian/search?${apiParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      if (!Array.isArray(data?.results)) {
        setAddressOptions([]);
        return;
      }

      setAddressOptions(data.results);
    }
    catch (e: any) {
      setAddressOptions([]);
      throw e;
    }
  };

  return {
    addressOptions,
    handleChange
  };
};

export default useAutocompleteAddress;